module.exports = __webpack_public_path__ + "assets/img/icon4-menu.7e5632e9.svg";